const FormDropdown = (props) => {
  return (
    <>
      <select {...props} className="rounded-md min-w-full border-gray-300">
        <option value="">Choose an option</option>
        {props.options.map((option, idx) => {
          return (
            <option value={`${JSON.stringify(option)}`} key={`option-${idx}`}>
              {option.label}
            </option>
          );
        })}
      </select>
    </>
  );
};

export default FormDropdown;
